export const updateImportsState = (prevImports, selectedLeft, selectedSourcePhaseId, targetPhaseId, checkedRight) => {
	const targetIds = Object.keys(checkedRight).filter((key) => checkedRight[key]);
	const existingImport = prevImports.find((imp) => imp.sourceDeliverableId === selectedLeft);
	const preservedId = existingImport?.id ?? null;

	let newResult;

	if (targetIds.length === 0) {
		newResult = prevImports.filter((imp) => imp.sourceDeliverableId !== selectedLeft);
	} else {
		const newMapping = {
			...(preservedId && { id: preservedId }),
			sourcePhaseId: selectedSourcePhaseId,
			targetPhaseId,
			sourceDeliverableId: selectedLeft,
			targetDeliverableIds: targetIds,
		};

		newResult = existingImport
			? prevImports.map((imp) => (imp.sourceDeliverableId === selectedLeft ? newMapping : imp))
			: [...prevImports, newMapping];
	}

	try {
		const prevJson = JSON.stringify(prevImports || []);
		const newJson = JSON.stringify(newResult || []);
		if (prevJson === newJson) {
			return prevImports;
		}
	} catch (e) {
		console.error(e);
	}

	return newResult;
};

export const restoreCheckedStateFromImport = (imports, deliverableId) => {
	const existingImport = imports.find((imp) => imp.sourceDeliverableId === deliverableId);
	if (existingImport && Array.isArray(existingImport.targetDeliverableIds)) {
		const checked = {};
		existingImport.targetDeliverableIds.forEach((id) => {
			checked[id] = true;
		});
		return checked;
	}
	return {};
};
